import React, { ReactNode } from "react";
import "./Button.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGear } from "@fortawesome/free-solid-svg-icons";

type ButtonProps = {
  type?: "brand" | "success" | "danger";
  children: ReactNode;
  icon?: ReactNode;
  iconSlot?: "start" | "end";
  expand?: boolean;
  class?: string;
  callback: () => void;
  disabled?: boolean;
  loading?: ButtonLoadingStateProps;
};

export type ButtonLoadingStateProps = {
  state: boolean;
  text: string;
};

export function Button(props: ButtonProps) {
  function buildClass() {
    const className = ["btnContainer"];
    if (props.class) className.push(props.class);
    if (props.expand) className.push("btnExpand");

    if (props.disabled) {
      className.push("btnDisabled");
      return className.join(" ");
    }

    switch (props.type) {
      case "success":
        className.push("btnSuccess");
        break;
      case "danger":
        className.push("btnDanger");
        break;
      default:
        className.push("btnBrand");
        break;
    }

    return className.join(" ");
  }

  function buildLoadingClass() {
    const className = ["btnContainer", "btnDisabled"];
    if (props.class) className.push(props.class);
    if (props.expand) className.push("btnExpand");
    return className.join(" ");
  }

  if (props.loading?.state) {
    return (
      <button className={buildLoadingClass()} disabled>
        {props.iconSlot === "start" && <FontAwesomeIcon icon={faGear} spin />}
        <span>{props.loading.text}</span>
        {props.iconSlot !== "start" && <FontAwesomeIcon icon={faGear} spin />}
      </button>
    );
  }

  return (
    <button
      className={buildClass()}
      onClick={props.callback}
      disabled={props.disabled}
    >
      {props.iconSlot === "start" && props.icon}
      {props.children}
      {props.iconSlot === "end" && props.icon}
    </button>
  );
}
